import { ProgressActions } from "./action";

const initialState = {
  progress: []
};

const ProgressReducer = (state = initialState, action) => {
  switch (action.type) {
    case ProgressActions.GET_PROGRESS_SUCCESS:
      return {
        ...state,
        progress: action.payload,

      };

    case ProgressActions.GET_PROGRESS_ERROR:
      return {
        ...state,
        progress: []
      };


    default:
      return state;
  }
};

export default ProgressReducer;
